module.exports = __webpack_public_path__ + "media/packs/images/state/containers_assigned-7391d03dca5b4f06934516ced857326a.svg";